export default function () {
  return [
    {
      type: 'Input',
      title: '组织层级',
      [$field]: 'allName',
      colSpan: 16,
      rules: ['']
    },
    {
      type: 'Input',
      title: '党组织全称',
      [$field]: 'orgName',
      rules: ['']
    },
    {
      type: 'Input',
      title: '党组织简称',
      [$field]: 'shortName',
      rules: ['']
    },
    {
      type: 'Input',
      title: '党组织书记',
      [$field]: 'partyOrgLeader',
      rules: []
    },
    // {
    //   type: 'Input',
    //   title: '党组织书记电话',
    //   [$field]: 'partyOrgLeaderPhone',
    //   rules: []
    // },
    // {
    //   type: 'Input',
    //   title: '党组织委员',
    //   [$field]: 'partyOrgCommitteeMember',
    //   rules: []
    // },
    // {
    //   type: 'Input',
    //   title: '党组织委员电话',
    //   [$field]: 'partyOrgCommitteePhone',
    //   rules: []
    // },
    {
      type: 'Input',
      title: '上级党组织简称',
      readOnly: true,
      [$field]: 'upShortName'
    },
    {
      type: 'Input',
      title: '上级党组织书记',
      readOnly: true,
      [$field]: 'upOrgLeader'
    },
    {
      type: 'Input',
      title: '上上级党组织简称',
      readOnly: true,
      [$field]: 'upUpShortName'
    },
    {
      type: 'Input',
      title: '上上级党组织书记',
      readOnly: true,
      [$field]: 'upUpOrgLeader'
    },
    // {
    //   type: 'Input',
    //   title: '上级党组织书记电话',
    //   [$field]: 'upOrgLeaderPhone',
    //   rules: []
    // },
    {
      type: 'DatePicker',
      title: '党组织应换届日期',
      [$field]: 'nextChangeTime',
      rules: ['']
    },
    {
      type: 'DatePicker',
      title: '党组织上次换届日期',
      [$field]: 'lastChangeTime',
      rules: ['']
    },
    {
      type: 'Select',
      optionList: [
        {
          label: '是',
          value: '1'
        },
        {
          label: '否',
          value: '0'
        }
      ],
      title: '是否属地化',
      [$field]: 'isTerritoriesManagement',
      rules: []
    },
    {
      type: 'Input',
      title: '属地化单位上级党组织全称',
      [$field]: 'territoriesOrgName',
      rules: []
    }
  ]
}